<template>
  <v-alert :type="alertType" v-if="alertData.length> 0" class="alerts">
    <p>
      {{caption}}
      <span>{{alertData.join(`${separator} `)}}</span>
    </p>
    <v-btn small text @click="$emit('onClose','close')" v-if="closed">&times;</v-btn>
  </v-alert>
</template>
<script>
export default {
  name: "alert",
  data: () => ({}),
  props: {
    alertData: { type: Array, required: true },
    caption: { type: String, default: "Sample text" },
    separator: { type: String, default: "," },
    alertType: { type: String, default: "error", required: true },
    closed: { type: Boolean, default: false },
  },
};
</script>
<style lang='sass'></style>